import bffAxiosInstance from 'App/bffAxios';
import { Country } from 'App/i18n/enums';
import { Plan } from 'commons/services/configurationService';

const getPlans = async (
  regionalPaymentGatewayId: Country,
  custom: boolean,
  active: boolean,
): Promise<Plan[]> => {
  const response = await bffAxiosInstance.get<Plan[]>(
    `/payments/plans/available?regionalPaymentGatewayId=${regionalPaymentGatewayId}&custom=${custom}&active=${active}`,
  );
  return response.data;
};

export default getPlans;
